<template>
  <div :class="['main-page findLawyer',{xiaodu:isXiaodu}]">
    <Menu
      title="律师查询"
      :home="true"
    >
      <template slot="left-link">
        <a
          href="javascript:;"
          @click="goPrevious()"
        ></a>
      </template>
    </Menu>
    <div
      class="container-flex lawyer-container"
      :style="{ 'margin-top': isXiaodu && '120px'}"
    >
      <div class="left">
        <div class="sider">
          <div class="ht">律师搜索</div>
          <div class="search-content">
            <input
              type="text"
              class="form-control input-lg"
              placeholder="请输入律师名称"
              v-model="inputValue"
              @keydown="checkEnter($event)"
              maxlength='5'
            >
            <button
              type="submit"
              class="btn btn-primary btn-lg"
              @click="search_pop($event)"
            >
              搜索
            </button>
          </div>
          <div class="ht">区域选择</div>
          <div class="area-content">
            <div
              class="item"
              :class="areaIndex[0]==index ? 'btn btn-primary btn-lg':'btn btn-default btn-lg' "
              v-for="(item, index) of areaList"
              :key="index"
              @click="areaIndex[0]=index,page = 1;  getLawyer(index, year, prof, 1), areaIndex[1]='', switchList()"
            >{{item.alias}}</div>

          </div>
          <div
            class="area-content"
            v-if="areaIndex[0]"
          >
            <div
              class="item"
              :class="areaIndex[1] == index ? 'btn btn-primary btn-lg':'btn btn-default btn-lg'"
              v-for="(item, index) of areaList[areaIndex[0]].children"
              :key="index"
              @click="areaIndex[1] = index, page = 1; getLawyer(index, year, prof, 1), switchList()"
            >{{item.alias}}</div>

          </div>
        </div>
      </div>
      <div
        class="right"
        v-if="initial"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
      >
        
        <div class="lawyer-list ly-column">
          <div
            class="item"
            v-for="(item, index) in res"
            :key="'res'+ index"
            @click="handleShowLawyer(item)"
          >
            <img
              :src="item.zp"
              alt=""
              v-if="item.zp"
            >
            <img
              src="/img/ui/lawyer_avatar.png"
              alt=""
              v-else
            >

            <div class="content">
              <div class="name">
                {{item.xm}}
              </div>
              <div class="skill">
                执业类别：{{item.zylb}}
              </div>
              <div>
                <!-- <span> 执业年限： {{item.practice}}年</span> -->
                执业证号：{{item.zyzh || '暂无'}}<br> 电话：{{item.lxfs || '暂无'}}
              </div>
            </div>

          </div>
        </div>

      </div>

      <div
        class="right"
        v-if="putwords"
      >
        <div class="lawyer-list">
          <div class="result-ht">
            名字包含“{{inputValue}}”的律师一共有 {{popList.length}} 人
          </div>
        </div>
        <div class="lawyer-list ly-column">
          <div
            class="item"
            v-for="(item, index) in popList"
            :key="'res'+ index"
            @click="handleShowLawyer(item)"
          >
            <img
              :src="item.zp"
              alt=""
              v-if="item.zp"
            >
            <img
              src="/img/ui/lawyer_avatar.png"
              alt=""
              v-else
            >

            <div class="content">
              <div class="name">
                {{item.xm}}
              </div>
              <div class="skill">
                执业类别：{{item.zylb}}
              </div>
              <div>
                <!-- <span> 执业年限： {{item.practice}}年</span> -->
                职业证号：{{item.zyzh || '暂无'}}<br> 电话：{{item.lxfs || '暂无'}}
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>

    <div
      class="lawyer-about"
      v-if="showLawyer"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="lawyer">
              <div class="content">
                <div
                  v-if="currentlawyer.zp"
                  class="imgs"
                  :style="'background-image:url('+currentlawyer.zp+')'"
                ></div>
                <div
                  v-else
                  class="imgs"
                  style="background-image:url('/img/ui/lawyer_avatar.png')"
                ></div>
                <div class="intro">
                  <strong class="name">{{ currentlawyer.xm }}</strong>
                  <div class="rate">
                    <div>
                        <i v-for="item in 5"
                          class="glyphicon glyphicon-star"
                          :key="item"
                          :class="{on:item<6}"
                        ></i>
                     
                    </div>
                    <span>电话：{{ currentlawyer.lxfs || '暂无' }}</span>
                  </div>
                  <div class="lawfir">{{ currentlawyer.firm_name || '暂无' }}</div>
                </div>
                <div class="sc">
                  <ul>
                    <li>执业证号：{{ currentlawyer.zyzh }}</li>
                    <li style="width:100%">擅长专业：{{ currentlawyer.adept || '暂无' }}</li>
                    <li style="width:100%">执业类别：{{ currentlawyer.zylb || '暂无'  }}</li>
                    <li style="width:100%">所在律所：{{ currentlawyer.firm_name || '暂无'  }}</li>
                    <li style="width:100%">联系地址：{{ currentlawyer.firm_address || '暂无'  }}</li>
                  </ul>
                </div>
              </div>
              <div
                class="body"
                v-if="currentlawyer.desc"
              >
                <div class="ht">
                  律师简介
                </div>
                <div
                  class="detail"
                  v-html="currentlawyer.desc"
                >
                </div>
              </div>
              <a
                v-if="currentlawyer.lxfs"
                href="javascript:void(0)"
                class="btn btn-success btn-zxls"
                @click="getLawyerTel"
              >咨询该律师</a>
              <Dialogs v-model="dialog">
                <div class="lawyer-intro-rate">
                  <div class="lawyer-intro--info">
                    <div class="name">{{currentlawyer.xm}} 律师</div>
                    <div class="tel">
                      咨询电话
                      <strong>{{currentlawyer.lxfs || '暂无'}}</strong>
                    </div>
                  </div>
                  <div class="lawyer-intro--tip">
                    咨询完成后可对律师服务进行评价打分
                  </div>
                  <div class="lawyer-intro--rates">
                    <Rate
                      title="服务态度"
                      v-model="rate.lawyerAttitude"
                    />
                    <Rate
                      title="专业度"
                      v-model="rate.lawyerQuality"
                    />
                  </div>
                </div>

                <template slot="foot">
                  <a
                    :class="rate.lawyerAttitude>0 && rate.lawyerQuality>0 ? 'lp-btn large primary': 'lp-btn large default'"
                    @click="updateRate"
                    class="submit-btn"
                  >提交评价</a>
                  <a
                    class="lp-btn large default submit-btn"
                    @click="closeRate"
                  >不评价</a>
                </template>
              </Dialogs>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Menu from '@/components/Menu'
import Dialogs from '@/components/Dialog'
import Rate from '@/components/Rate'
import { residence } from '../datas/js/config.js'
import { LAWYER_INQUIRE } from '../datas/constants/statistics.js'
export default {
  data () {
    return {
      isXiaodu: localStorage.getItem('xiaodu') || false,
      areaIndex: ['530100', ''],
      residence,
      year_tag: {
        11: '10年以上',
        5: '5~10年',
        4: '1~4年',
        1: '1年以下',
        0: '全部'
      },
      year: 0,
      skill: {
        0: '全部',
        1: '婚姻问题',
        2: '劳动纠纷',
        3: '工伤赔偿',
        4: '交通事故',
        5: '借贷纠纷',
        6: '遗产继承',
        7: '买房纠纷',
        8: '物业服务纠纷',
        9: '产品质量纠纷',
        10: '电子产品分期'
      },
      prof: 0,
      resi: '530100',
      res: [],
      page: 1,
      pageSize: '',
      step: 0,
      inputValue: '',
      popList: [],
      dialog: {
        maskClose: true,
        show: false
      },
      rate: {
        isRate: false,
        lawyerAttitude: -1,
        lawyerQuality: -1
      },
      showLawyer: false,
      initial: true,
      putwords: false,
      busy: false,
      all: '',
    }
  },
  components: {
    Menu,
    Dialogs,
    Rate
  },
  computed: {
    web_code () {
      return this.$store.state.device.config.web_code
    },
    point () {
      return this.$store.state.device.point
    },
    areaList () {
      return this.$store.state.device.area
    }

  },

  async mounted () {
    this.areaIndex = [this.web_code, this.point.code]
    this.getLawyer(this.point.code, 0, 0, 1)
    this.$root.getStatistics(LAWYER_INQUIRE)
  },
  methods: {
    /* eslint-disable */
    computeYear (year) {
      year = parseInt(year)
      let begin = ''
      let end = ''
      if (year === 0) {
        begin = ''
        end = ''
      } else if (year === 1) {
        begin = 0
        end = 1
      } else if (year === 4) {
        begin = 1
        end = 5
      } else if (year === 5) {
        begin = 5
        end = 10
      } else {
        begin = 10
        end = ''
      }
      return `&begin=${begin}&end=${end}`
    },
    updateRate () {
      const { lawyerAttitude, lawyerQuality, isRate } = this.rate
      if (lawyerAttitude > 0 && lawyerQuality > 0 && !isRate) {
        this.rate.isRate = true
        this.alert = {
          show: true,
          info: '评价成功！',
          recall: this.closeRate
        }
      }
    },
    closeRate () {
      this.dialog.show = false
      this.rate = {
        isRate: false,
        lawyerAttitude: -1,
        lawyerQuality: -1
      }
    },
    getLawyerTel () {
      this.dialog.show = true
    },
    /* eslint-enable */
    async getLawyer (resi, year, prof, type = false) {
      // const cYear = this.computeYear(year)

      prof = prof > 0 ? this.skill[prof] : ''
      this.$loading.show()
      let gain = await this.$get(
        'https://yn.12348.laway.cn/gfy/api/ls/lawyer/?code=' +
        resi +
        '&xm=' +
        this.inputValue +
        '&page=' +
        this.page +
        '&per_page=30'
      )
      this.all = gain.result.count
      console.log('律师列表', gain)
      if (type) {
        this.res = []
        this.res = gain.result.data
        this.page = 1
        this.pageSize = gain.result.num_pages
      } else {
        this.res.push(...gain.result.data)
        this.pageSize = gain.result.num_pages
      }
      this.$loading.hide()
    },
    filterLawyer (year, prof) {
      let [city, county] = this.areaIndex // city 州市代码   county 区县代码
      this.year = year
      this.prof = prof

      if (city === '530102') {
        county = ''
      }
      // console.log('areaCode', typeof (this.web_code))
      // console.log('city', typeof (city))
      // console.log('county', typeof (county))
      let code = ''
      if (!county) {
        code = city
      } else {
        code = county
      }
      console.log('code', code)

      this.getLawyer(code, year, prof, 1)
    },
    goback () {
      if (this.step > 1) {
        this.step = 1
      }
    },
    goPrevious () {
      !this.showLawyer ? this.$router.go(-1) : this.showLawyer = false
    },
    handleShowLawyer (item) {
      this.showLawyer = true
      this.currentlawyer = item
    },
    async search_pop () {
      this.initial = false
      this.putwords = true
      let ly = await this.$get('https://yn.12348.laway.cn/gfy/api/ls/lawyer/?xm=' + this.inputValue)
      this.popList = []
      this.popList.push(...ly.result.data)
    },
    checkEnter (e) {
      let et = e || window.event
      let code = et.keyCode || et.charCode
      if (code === 13) {
        if (window.event) {
          window.event.returnValue = false
        } else {
          et.preventDefault()
        }
      }
    },
    switchList () {
      this.initial = true
      this.putwords = false
      this.inputValue = ''
    },
    loadMore () {
      if (this.page < this.pageSize && !this.busy) {
        this.page = this.page === 1 ? 2 : this.page
        console.log('当前页', this.page)
        this.$loading.show()
        this.busy = true
        this.resi = this.areaIndex[1] ? this.areaIndex[1] : this.areaIndex[0]
        var that = this
        setTimeout(() => {
          that.getLawyer(this.resi, this.year, this.prof)
          that.page++
          that.busy = false
        }, 1000)
      }
    }
  }
}
</script>

<style lang="stylus">
.select_area
  height 100vh
  display flex
  justify-content center
  align-items center
  position fixed
  left 0
  top 0
  right 0
  bottom 0
  z-index 10000
  background rgba(0, 0, 0, 0.5)
  .wrap
    background #fff
    border-radius 0.1rem
    width 12rem
    margin 0.25rem auto
    padding 0.35rem
    text-align center
    .ht
      font-size 0.28rem
      padding-bottom 0.2rem
      color #555
    .content
      display flex
      flex-wrap wrap
      a
        width 33.33%
        span
          padding 0.15rem 0
          display block
          font-size 0.2rem
          background #eee
          margin 0 0.1rem 0.1rem 0
.lawyer-intro-rate
  margin 0.1rem 0.8rem 0.6rem
  .lawyer-intro--rates
    display flex
    justify-content center
    align-items center
    flex-direction column
    .item-content
      margin-bottom 0.1rem
    .item-inner
      display flex
      align-items center
      padding 0 0.15rem
      font-size 0.36rem
      color #ccc
      .item-title
        font-size 0.26rem
        color #555
        width 1.4rem
        display flex
        justify-content flex-end
        align-items center
      .starts
        display flex
        align-items center
        .on
          color #ffcc00
        span
          padding-left 0.15rem
          font-size 0.2rem
          color #555
  .lawyer-intro--tip
    text-align center
    padding 0.3rem
    font-size 0.18rem
    color #999
  .lawyer-intro--info
    border-bottom 0.01rem solid #eee
    text-align center
    padding 0 0 0.2rem
    .name
      font-size 0.28rem
      color #808080
    .tel
      font-size 0.36rem
      display flex
      justify-content center
      align-items center
      padding 0.15rem 0
      strong
        padding-left 0.15rem
        font-size 0.48rem
        color #3d69bd
.findLawyer
  min-height 100vh
 
  .lawyer-list
    padding-bottom 0.8rem
    .item
      border 0.01rem solid #eee
      padding 0.25rem
      display flex
      margin-bottom 0.3rem
      &:active
        background #f7f7f7
      .imgs
        width 0.72rem
        height 0.72rem
        background-size cover
        background-position center 0
        flex-shrink 0
        border-radius 50%
        margin-right 0.1rem
      .lawyer-name
        font-size 0.18rem
        color #333
      .lawyer-tell
        font-size 0.14rem
        color #808080
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 1
        overflow hidden
      .lawyer-intro
        font-size 0.14rem
        color #808080
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 1
        overflow hidden
  .ly-column
    display flex
    justify-content space-between
    flex-wrap wrap
    .item
      width 49%
      img
        width 1rem
        height 1rem
        border-radius 50%
        margin-right 0.2rem
  .lawyer-about
    position fixed
    left 0
    right 0
    bottom 0
    top 1.2rem
    overflow-y scroll
    z-index 2100
    background #ddd
    .lawyer
      padding-bottom 1.2rem
      .btn-zxls
        display flex
        justify-content center
        align-items center
        height 0.6rem
        font-size 0.24rem
        margin 40px 20% 0
      .content
        margin 1rem 0 0.1rem
        border-radius 0.05rem
        position relative
        border-bottom 0.01rem solid #ddd
        .imgs
          position absolute
          top -0.75rem
          left 50%
          margin-left -0.75rem
          width 1.5rem
          height 1.5rem
          border 0.03rem solid #fff
          border-radius 50%
          background-size cover
          background-color #fff
          background-position center 0
          box-shadow 0 0.03rem 0.05rem rgba(0, 0, 0, 0.3)
        .sc
          background #fff
          padding 0.35rem
          border-radius 0 0 0.05rem 0.05rem
          color #808080
          font-size 0.2rem
          ul
            display flex
            flex-wrap wrap
            li
              width 50%
              padding-bottom 0.2rem
        .tel
          display flex
          justify-content center
          align-items center
          padding 0.15rem
          border-radius 0 0 0.05rem 0.05rem
          color #999
          .icon
            color #4caf50
      .body
        background #fff
        padding 0.25rem
        min-height 0.7rem
        color #555
        border-radius 0.05rem
        border-bottom 0.01rem solid #ddd
        .ht
          border-bottom 0.01rem solid #eee
          padding-bottom 0.1rem
          margin-bottom 0.1rem
          font-size 0.24rem
          font-weight bold
        .detail
          padding 0.3rem
          font-size 0.18rem
      .intro
        padding 1.05rem 0.15rem 0.5rem
        border-radius 0.05rem 0.05rem 0 0
        background #1488cc
        /* fallback for old browsers */
        background -webkit-linear-gradient(to right, #2b32b2, #1488cc)
        /* Chrome 10-25, Safari 5.1-6 */
        background linear-gradient(to right, #2b32b2, #1488cc)
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        .name
          display block
          text-align center
          color #fff
          font-size 0.36rem
          margin-bottom 0.05rem
        .lawfir
          padding-top 0.1rem
          color #fff
          opacity 0.6
          text-align center
          font-size 0.18rem
        .rate
          text-align center
          font-size 0.24rem
          color rgba(255, 255, 255, 0.2)
          .on
            color #fff100
          span
            color #fff
            padding 0 0.15rem
  .lawfirm-about
    position fixed
    left 0
    right 0
    bottom 0
    top 1.59rem
    overflow-y scroll
    z-index 2100
    background #ddd
    .container
      background #fff
      margin 0.3rem auto 0.8rem
      padding 0.6rem
    .ht
      font-size 0.32rem
      font-weight bold
      padding 0.3rem
      border-bottom 0.01rem solid #ddd
      margin-bottom 0.3rem
      text-align center
    .detail
      font-size 0.18rem
      padding 0.3rem
      p
        margin-bottom 0.2rem
  .lawfirm-detail
    .content
      position fixed
      top 1.59rem
      right 0
      bottom 0
      left 30%
      background #fff
      z-index 2000
      padding 0.4rem
      overflow-y scroll
      font-size 0.16rem
      .name
        font-size 0.28rem
        padding-bottom 0.2rem
        padding 0.2rem 0
      .info
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 3
        overflow hidden
        p
          margin-bottom 0
          display none
          &:first-child
            display block
      .ht
        font-size 0.2rem
        color #555
        line-height 1
        border-left 0.05rem solid #558ce1
        padding-left 0.1rem
        margin 0.35rem 0 0.15rem
    .contact
      padding-bottom 0.15rem
      border-bottom 0.01rem solid #ddd
      div
        margin-bottom 0.1rem
        display flex
        align-items center
        span
          color #558ce1
          display inline-flex
          align-items center
    .mask
      position fixed
      top 1.58rem
      left 0
      right 0
      bottom 0
      background rgba(0, 0, 0, 0.5)
      z-index 1000
  .lawyer-container
    display flex
    overflow hidden
    .left, .right
      height 100%
      overflow-y scroll
      padding 0.1rem 0 1.2rem
      // padding 10px 0 20px
    .left
      width 25%
      
      background #fff
    .right
      padding-top 0
      width 75%
    .lawyer-list
      padding 0 0.4rem 0 0.4rem
      .result-ht
        font-size 0.2rem
        padding-bottom 0.2rem
        color #fff
        strong
          color red
      .item
        display block
        background #fff
        margin-bottom 0.2rem
        padding 0.25rem 0.4rem 0.25rem 0.25rem
        font-size 0.16rem
        color #808080
        border-radius 0.05rem
        display flex
        align-items center
        &:active
          background #f7f7f7
        .content
          flex 1
          .name
            color #555
            font-size 0.24rem
            padding-bottom 0.1rem
        .glyphicon
          flex-shrink 0
          font-size 0.24rem
          color #ddd
    .sider
      .ht
        padding 0.2rem
        font-size 0.24rem
        color #808080
      .area-content
        padding 0 0 0.2rem 0.2rem
        .item
          margin 0 0.1rem 0.1rem 0
      .search-content
        padding 0 0.2rem
        display flex
        input
          border-radius 0.06rem 0 0 0.06rem
          border-right 0
        .btn
          flex-shrink 0
          border-radius 0 0.06rem 0.06rem 0
</style>
